'use client';

import React from 'react';
import styled from 'styled-components';

interface MonitorIntervalSectionProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const Container = styled.div``;

const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  display: block;
  margin-bottom: 12px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const IntervalButton = styled.button<{ $active?: boolean; $premium?: boolean }>`
  padding: 10px 20px;
  background: ${props => props.$active ? '#FB6F2A' : '#ffffff'};
  border: 1px solid ${props => props.$active ? '#FB6F2A' : '#e5e7eb'};
  border-radius: 8px;
  color: ${props => props.$active ? '#ffffff' : props.$premium ? '#FB6F2A' : '#6b7280'};
  font-size: 14px;
  font-weight: 500;
  cursor: ${props => props.$premium ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.$active ? '#D33324' : props.$premium ? '#FFF7ED' : '#f5f5f5'};
    border-color: ${props => props.$active ? '#D33324' : props.$premium ? '#FDE68A' : '#d1d5db'};
  }
`;

const PremiumBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 8px;
  background: #FFF7ED;
  color: #FB6F2A;
  border: 1px solid #FDE68A;
  padding: 2px 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
`;

export const MonitorIntervalSection: React.FC<MonitorIntervalSectionProps> = ({
  value,
  onChange,
  className,
}) => {
  const intervals = ['30s', '1m', '5m', '30m', '1h', '12h', '24h'];
  const premiumIntervals = new Set(['30s', '1m']);

  return (
    <Container className={className}>
      <Label>Monitor interval</Label>
      <ButtonGroup>
        {intervals.map((interval) => {
          const isPremium = premiumIntervals.has(interval);
          return (
            <IntervalButton
              key={interval}
              type="button"
              $active={value === interval}
              $premium={isPremium}
              onClick={() => {
                if (!isPremium) onChange(interval);
              }}
              title={isPremium ? 'Premium interval' : undefined}
            >
              {interval}
              {isPremium && (
                <PremiumBadge>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="#FB6F2A" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2l3 7h7l-5.5 4.5L18 21l-6-4-6 4 1.5-7.5L2 9h7l3-7z" />
                  </svg>
                  Premium
                </PremiumBadge>
              )}
            </IntervalButton>
          );
        })}
      </ButtonGroup>
    </Container>
  );
};

export default MonitorIntervalSection;

